
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipNoCommandA as ObiOwnShipNoCommandAElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-no-command-a.js';
 
 
 

 
 export const ObiOwnShipNoCommandA = createComponent({
   react: React,
   tagName: 'obi-own-ship-no-command-a',
   elementClass: ObiOwnShipNoCommandAElement,
   events: {
     
   }
  });
 
 